module.exports = __webpack_public_path__ + "static/media/btn_minus.34a3dfda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/btn_minus.svg
// module id = 1097
// module chunks = 0